import { VNode, shallowRef } from 'vue';

export const showing_floating_toolbar = shallowRef(false);

export const floating_toolbar_position = shallowRef({ left: 0, top: 0 });

export const floating_toolbar_buttons = shallowRef([] as Array<string | VNode>);
